import React, { useCallback } from 'react';

import Container from '@material-ui/core/Container';

import { makeStyles } from '@material-ui/core';

import Button from '@material-ui/core/Button';
import DialogWithEnterAction from '../components/DialogWithEnterAction';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { GetSaveButtonStyle as saveButtonStyle } from '../Styles/styles';
import { Box } from '@material-ui/core';
import { TokenTypeSelect, ReadWriteSelect } from '../FormWidgets/Select';

import { settings_dependancies } from '../Constants/constants';

import getStateManager from '../StateManager.js';
import { groupedAccessRights } from '../Utils/access_rights';

const mm = {
  marginTop: 15
};

const useAccessRights = (user, setUser, subuser, macAddress) => {
  console.log('[UR]: called with: ', subuser, macAddress);
  console.log('[UR]: user:', user);
  const isReady = Boolean(subuser && macAddress);
  const access_rights = isReady
    ? user?.sub_users?.[subuser]?.per_controller?.[macAddress]
    : undefined;

  const setAccessRights = useCallback(
    (newAccessRights) => {
      if (!isReady) return;

      setUser((prev) => {
        const existingSubUser = prev.sub_users?.[subuser] ?? {};
        const existingControllers = existingSubUser.per_controller ?? {};
        const existingAccessRights = existingControllers[macAddress] ?? {};

        return {
          ...prev,
          sub_users: {
            ...prev.sub_users,
            [subuser]: {
              ...existingSubUser,
              per_controller: {
                ...existingControllers,
                [macAddress]: {
                  ...existingAccessRights,
                  ...newAccessRights
                }
              }
            }
          }
        };
      });
    },
    [setUser, subuser, macAddress]
  );

  return [access_rights, setAccessRights];
};

export default function UserManagePage({ user, setUser }) {
  let { t } = useTranslation();
  let { enqueueSnackbar } = useSnackbar();

  // Add User Dialog
  const [open_add_user_dialog, setOpenAddUserDialog] = React.useState(false);
  const openAddUserDialog = () => {
    setOpenAddUserDialog(true);
  };
  const closeAddUserDialog = () => {
    setOpenAddUserDialog(false);
  };

  const [delete_dialog, setOpenDeleteDialog] = React.useState({ open: false, username: '' });
  const openDeleteDialog = (username) => {
    setOpenDeleteDialog({ open: true, username: username });
  };
  const closeDeleteDialog = () => {
    setOpenDeleteDialog({ open: false, username: '' });
  };
  const [restrictions_dialog, setOpenAccessRightsDialog] = React.useState({
    open: false,
    subuser: '',
    displayName: '',
    macAddress: ''
  });
  const openAccessRightsDialog = (subuser, displayName, macAddress) => {
    setOpenAccessRightsDialog({
      open: true,
      subuser: subuser,
      displayName: displayName,
      macAddress: macAddress
    });
  };
  const closeAccessRightsDialog = () => {
    setOpenAccessRightsDialog({ open: false, subuser: '', displayName: '', macAddress: '' });
  };

  const setAccess = (subuser, write) => {
    const req = JSON.stringify({ username: subuser, write: write });
    fetch('/api/access/update/general', { method: 'POST', body: req })
      .then((response) => {
        if (response.ok) {
          response
            .text()
            .then((text) => enqueueSnackbar(t('updated_restrictions'), { variant: 'info' }));
          const sub_users = user.sub_users;
          sub_users[subuser].general.write = write;
          setUser((prev) => ({ ...prev, ...sub_users }));
        } else {
          response.text().then((text) => enqueueSnackbar(t(text), { variant: 'error' }));
        }
      })
      .catch((_) => enqueueSnackbar(t('unknown_error'), { variant: 'error' }));
  };

  const stateManager = getStateManager();
  console.log('access_rights (UMP): ', user);

  if (!user.admin) {
    return <React.Fragment>You are no admin user</React.Fragment>;
  }
  return (
    <Container style={mm}>
      <AddUserDialog open={open_add_user_dialog} handleClose={closeAddUserDialog} />
      <DeleteSubUserDialog
        open={delete_dialog.open}
        handleClose={closeDeleteDialog}
        username={delete_dialog.username}
        user={user}
        setUser={setUser}
      />
      <AccessRightsDialog
        open={restrictions_dialog.open}
        handleClose={closeAccessRightsDialog}
        subuser={restrictions_dialog.subuser}
        displayName={restrictions_dialog.displayName}
        macAddress={restrictions_dialog.macAddress}
        user={user}
        setUser={setUser}
      />
      <Box style={saveButtonStyle()}>
        <Button onClick={openAddUserDialog} color="primary">
          {t('add_user_dialog')}
        </Button>
      </Box>

      {Object.keys(user.sub_users).length > 0 && (
        <TableContainer component={Paper}>
          <Table aria-label="table of controllers">
            <TableHead>
              <TableRow>
                <TableCell>Username</TableCell>
                <TableCell>General</TableCell>
                {Object.keys(
                  user.sub_users[Object.keys(user.sub_users)[0]].per_controller || {}
                ).map((macAddress) => (
                  <TableCell>{stateManager.getControllerByMacAddress(macAddress).name}</TableCell>
                ))}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {[...Object.keys(user.sub_users)].map((sub_user) => (
                <TableRow key={sub_user}>
                  <TableCell>{sub_user}</TableCell>
                  <TableCell>
                    <TokenTypeSelect
                      value={user.sub_users[sub_user].general.write ? 'write' : 'read'}
                      onChange={(event) => setAccess(sub_user, event.target.value === 'write')}
                    />
                  </TableCell>
                  {Object.keys(user.sub_users[sub_user].per_controller || {}).map((macAddress) => (
                    <TableCell key={macAddress}>
                      <Button
                        onClick={() => {
                          openAccessRightsDialog(
                            sub_user,
                            stateManager.getControllerByMacAddress(macAddress).name,
                            macAddress
                          );
                        }}
                        color="secondary"
                      >
                        {t('edit')}
                      </Button>
                    </TableCell>
                  ))}
                  <TableCell>
                    <Button onClick={() => openDeleteDialog(sub_user)} color="secondary">
                      {t('delete_account')}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
}

function AddUserDialog({ open, handleClose }) {
  let { t } = useTranslation();
  let { enqueueSnackbar } = useSnackbar();
  const [username, setUsername] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [access, setAccess] = React.useState(false);
  const [password, setPassword] = React.useState(null);
  const [passwordConfirm, setPasswordConfirm] = React.useState(null);

  const createUser = () => {
    const req = JSON.stringify({
      id: username,
      email: email,
      access: access,
      pw1: password,
      pw2: passwordConfirm
    });
    fetch('api/create_user', { method: 'POST', body: req })
      .then((response) => {
        if (response.ok) {
          response.text().then((text) => enqueueSnackbar(t(text), { variant: 'info' }));
          window.location.reload();
        } else {
          response.text().then((text) => enqueueSnackbar(t(text), { variant: 'error' }));
        }
      })
      .catch((_) => enqueueSnackbar(t('unknown_error'), { variant: 'error' }));
    handleClose();
  };

  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={createUser}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{t('add_user_dialog')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="serial"
          label={t('username')}
          type="text"
          fullWidth
          onChange={(event) => setUsername(event.target.value)}
        />
        <TextField
          margin="dense"
          id="serial"
          label="E-Mail (optional)"
          type="text"
          fullWidth
          onChange={(event) => setEmail(event.target.value)}
        />
        <TokenTypeSelect
          value={access ? 'write' : 'read'}
          onChange={(event) => setAccess(event.target.value === 'write')}
        />
        <TextField
          margin="dense"
          id="serial"
          label={t('password')}
          type="password"
          fullWidth
          onChange={(event) => setPassword(event.target.value)}
        />
        <TextField
          margin="dense"
          id="serial"
          label={t('repeat_password')}
          type="password"
          fullWidth
          onChange={(event) => setPasswordConfirm(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('cancel')}
        </Button>
        <Button onClick={createUser} color="primary">
          {t('apply')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}

function DeleteSubUserDialog({ open, handleClose, username, user, setUser }) {
  let { t } = useTranslation();
  let { enqueueSnackbar } = useSnackbar();

  const deleteAccount = () => {
    console.log('deleteAccount: username: ', username);
    const req = JSON.stringify({ username: username });
    console.log('deleteAccount: payload: ', req);
    fetch('/api/del_subuser', { method: 'POST', body: req })
      .then((response) => {
        if (response.ok) {
          enqueueSnackbar(t('deleted_sub_user'), { variant: 'info' });
          const sub_users = user.sub_users;
          delete sub_users[username];
          setUser((prev) => ({ ...prev, ...sub_users }));
        } else {
          response.text().then((text) => enqueueSnackbar(text, { variant: 'error' }));
        }
      })
      .catch((error) => enqueueSnackbar('Deleting account failed: ' + error, { variant: 'error' }));
    handleClose();
  };

  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={deleteAccount}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{t('delete_account')}</DialogTitle>
      <DialogContent>{t('delete_sub_account_confirm')}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('cancel')}
        </Button>
        <Button onClick={deleteAccount} color="primary">
          {t('delete')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}

function AccessRightsDialog({
  open,
  handleClose,
  subuser,
  displayName,
  macAddress,
  user,
  setUser
}) {
  let { t } = useTranslation();
  let { enqueueSnackbar } = useSnackbar();

  const [access_rights, setAccessRights] = useAccessRights(user, setUser, subuser, macAddress);
  const [block, setBlock] = React.useState(false);

  const setAccess = (tab, value) => {
    setBlock(false);
    const accessRights = { read: value === 'read' || value === 'write', write: value === 'write' };
    const updated = groupedAccessRights({ ...access_rights, [tab]: accessRights });
    for (const [tab, dependancies] of Object.entries(settings_dependancies)) {
      if (tab in updated && updated[tab].write) {
        for (const dep of dependancies) {
          if (!updated[dep].read) {
            enqueueSnackbar(t('access_conflict_a') + tab + t('access_conflict_b') + dep + "'", {
              variant: 'error'
            });
            setBlock(true);
          }
        }
      }
    }
    setAccessRights(updated);
  };

  const saveControllerAccessRights = () => {
    const req = JSON.stringify({
      username: subuser,
      mac_address: macAddress,
      access_rights: groupedAccessRights(access_rights)
    });
    fetch('/api/access/update/controller', { method: 'POST', body: req })
      .then((response) => {
        if (response.ok) {
          response
            .text()
            .then((text) => enqueueSnackbar(t('updated_restrictions'), { variant: 'info' }));
        } else {
          response.text().then((text) => enqueueSnackbar(t(text), { variant: 'error' }));
        }
      })
      .catch((_) => enqueueSnackbar(t('unknown_error'), { variant: 'error' }));
    handleClose();
  };

  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      minHeight: '70vh',
      maxHeight: '70vh'
    }
  }));
  const classes = useStyles();

  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={saveControllerAccessRights}
      enterActionDisabled={block}
      aria-labelledby="form-dialog-title"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="form-dialog-title">
        {subuser} - {displayName}
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <TableHead>
            <TableRow>
              <TableCell>Tab</TableCell>
              <TableCell>Access</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Object.keys(access_rights || {}).filter((tab) => !['multi_out', 'overwr_io'].includes(tab)).map((tab) => (
              <TableRow key={tab}>
                <TableCell>{t(tab)}</TableCell>
                <TableCell>
                  <ReadWriteSelect
                    value={
                      access_rights[tab].write ? 'write' : access_rights[tab].read ? 'read' : 'none'
                    }
                    onChange={(event) => setAccess(tab, event.target.value)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {t('cancel')}
        </Button>
        <Button onClick={saveControllerAccessRights} color="primary" disabled={block}>
          {t('apply')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}
